import type { ILandingEventAggregates } from '@/entities/landing.entity';
import { LANDING_EVENT_TYPE_LABELS, type LandingEventType } from '@/entities/landing.entity';
import { cn } from '@/lib/utils';

const ORDER: LandingEventType[] = [
	'connect',
	'download',
	'form_submit',
	'telegram_auth_start',
	'telegram_auth_code',
	'telegram_auth_password',
	'telegram_auth_session',
];

interface LandingEventsAggregatesBarProps {
	aggregates: ILandingEventAggregates | undefined;
}

export default function LandingEventsAggregatesBar({ aggregates }: LandingEventsAggregatesBarProps) {
	if (!aggregates) return null;

	return (
		<div className='flex flex-wrap gap-1.5'>
			{ORDER.map(type => {
				const count = aggregates[type] ?? 0;
				if (count === 0) return null;
				const isTg = type.startsWith('telegram_auth_');
				return (
					<span
						key={type}
						className={cn(
							'inline-flex items-center gap-1 rounded-md border px-2 py-0.5 text-xs',
							isTg ? 'border-chart-4/30 bg-chart-4/10 text-chart-4' : 'border-border bg-muted/50 text-muted-foreground',
						)}
					>
						<span>{LANDING_EVENT_TYPE_LABELS[type]}</span>
						<span className='font-semibold tabular-nums'>{count}</span>
					</span>
				);
			})}
		</div>
	);
}
